import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

const slice = createSlice({
  name: 'views',
  initialState: {},
  reducers: {
    updatePagination: (state, action) => {
      const { key, pagination } = action.payload;
      const viewState = state[key] || {};
      return {
        ...state,
        [key]: {
          ...viewState,
          pagination: {
            ...viewState.pagination,
            ...pagination
          }
        }
      };
    },
    updateFilters: (state, action) => {
      const { key, filters, pagination } = action.payload;
      const viewState = state[key] || {};
      return {
        ...state,
        [key]: {
          ...viewState,
          filters: [...filters],
          pagination: {
            ...viewState.pagination,
            ...pagination
          }
        }
      };
    },
    updateSorters: (state, action) => {
      const { key, sorters, pagination } = action.payload;
      const viewState = state[key] || {};
      return {
        ...state,
        [key]: {
          ...viewState,
          sorters: [...sorters],
          pagination: {
            ...viewState.pagination,
            ...pagination
          }
        }
      };
    },
    updateSearchKeyword: (state, action) => {
      const { key, keywords, pagination } = action.payload;
      const viewState = state[key] || {};
      return {
        ...state,
        [key]: {
          ...viewState,
          keywords,
          pagination: {
            ...viewState.pagination,
            ...pagination
          }
        }
      };
    },
    resetState: (state, action) => {}
  }
});

const viewStateSelector = (state: RootState) => state.views;
/**
 * Creates a selector for a specific view key with an optional preload state.
 * @param viewKey - The key of the view in the state.
 * @param preloadState - The default state to return if the view key is not found.
 * @returns A selector function.
 */
export function createViewSelector<TState extends Record<string, any>>(
  viewKey: string
) {
  return createSelector(viewStateSelector, (viewState) => {
    const view = viewState[viewKey];
    return view as TState;
  });
}

export const ViewsReducer = slice.reducer;

export const {
  updatePagination,
  updateFilters,
  updateSorters,
  updateSearchKeyword,
  resetState
} = slice.actions;

export const VIEW_STATE_KEY = 'views';
